import { ReactElement, useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '@/auth';
import { NotFoundPage } from '@/pages';
import { RoutesEnum } from '@/shared/duck';

const AVAILABLE_ROUTES: string[] = Object.values(RoutesEnum);

const useRouteExists = (pathname: string) => {
  return useMemo(() => {
    return AVAILABLE_ROUTES.some(route => {
      const normalizedPath = pathname.replace(/\/$/, '');
      const normalizedRoute = route.replace(/\/$/, '');
      return normalizedPath === normalizedRoute;
    });
  }, [pathname]);
};

export const WithRouteGuard = ({ element }: { element: ReactElement }) => {
  const { isLoggedIn } = useAuth();
  const location = useLocation();
  const routeExists = useRouteExists(location.pathname);

  if (location.pathname === RoutesEnum.Welcome && isLoggedIn) {
    return <Navigate to={RoutesEnum.Root} replace />;
  }

  if (routeExists && !isLoggedIn && location.pathname !== RoutesEnum.Welcome) {
    return <Navigate to={RoutesEnum.Welcome} replace />;
  }

  if (!routeExists) {
    return <NotFoundPage />;
  }

  return element;
};